import React from "react";
import { FaArrowRight, FaShoppingBag, FaTrash } from "react-icons/fa";

type Props = {
  itemCount: number;
  totalAmount: number;
  onViewCart: () => void;
  onClearCart: () => void;
};

const S = {
  root: "pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center px-3 pb-[calc(10px+env(safe-area-inset-bottom,0px))] sm:px-4 md:px-6 lg:left-64 lg:right-0 lg:px-8",
  pill: "pointer-events-auto flex items-center gap-1.5 rounded-[1.35rem] border border-black/8 bg-white/90 p-1.5 shadow-md backdrop-blur-xl dark:border-white/8 dark:bg-black/90",
  cart: "flex items-center gap-2 rounded-[1rem] bg-gradient-to-r from-orange-500 to-amber-400 px-3 py-2 text-white active:scale-95 transition-transform touch-manipulation",
  badge: "rounded-full bg-white px-1.5 text-[10px] font-black text-orange-600 leading-5",
  summary: "flex flex-col items-start rounded-[1rem] bg-black/5 px-2.5 py-2 text-[10px] font-semibold text-slate-600 dark:bg-white/8 dark:text-slate-300",
  clear: "flex h-9 w-9 items-center justify-center rounded-xl border border-black/8 bg-black/6 text-gray-500 active:scale-90 transition-transform touch-manipulation dark:border-white/8 dark:bg-white/8 dark:text-gray-300",
};

const CartOverlay: React.FC<Props> = ({ itemCount, totalAmount, onViewCart, onClearCart }) => {
  if (itemCount === 0) return null;
  return (
    <div className={S.root}>
      <div className={S.pill}>
        <button className={S.cart} onClick={onViewCart} aria-label={`View cart, ${itemCount} items`}>
          <FaShoppingBag size={11} />
          <span className="text-[11px] font-bold">View Cart</span>
          <span className={S.badge}>{itemCount}</span>
          <FaArrowRight size={9} className="opacity-75" />
        </button>
        <div className={S.summary}>
          <span className="mt-0.5 text-[13px] font-black text-slate-900 dark:text-white">
            {"\u20B9"}{totalAmount.toFixed(0)}
          </span>
        </div>
        <button className={S.clear} onClick={onClearCart} aria-label="Clear cart">
          <FaTrash size={11} />
        </button>
      </div>
    </div>
  );
};

export default CartOverlay;
